/** @format */
import { Header } from "./Header";
import { Main } from "./Main";
function App() {
  return (
    <div className="App">
      <Header></Header>
      <Main></Main>
    </div>
  );
}

export default App;
